import brandName from "../../assets/ambhos_full_logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faYoutube,
  faFacebook,
  faInstagram,
  faLinkedin,
  faTwitter,
  faCcMastercard,
  faCcVisa,
  faCcPaypal,
} from "@fortawesome/free-brands-svg-icons";
import { animateScroll as scroll } from "react-scroll";
import { Link } from "react-router-dom";
import {
  faArrowRightArrowLeft,
  faShield,
  faAward,
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";
import useSheetForm from "../hooks/useSheetForm";
import validateInfo from "../hooks/validateInfo";

const handleScroll = () => {
  // window.scrollTo(0, 0);
  scroll.scrollToTop();
};

export default function Footer() {
  const {
    handleChange,
    subscribeFormData,
    handleSubmit,
    errors,
    isSubmitted,
    submitMessage,
  } = useSheetForm(validateInfo, "subscribeForm");

  return (
    <div className="z-50 bg-ambhosOrange">
      <hr className="mt-10" />
      <div className="py-5 flex justify-around text-md text-white">
        <div className="flex flex-col items-center space-y-4 md:space-y-2">
          <FontAwesomeIcon
            icon={faShield}
            className="text-2xl md:text-3xl text-white pr-3"
          />{" "}
          <p className="text-center">100% secure Payment</p>
        </div>
        <div className="flex flex-col items-center space-y-4 md:space-y-2">
          <FontAwesomeIcon
            icon={faArrowRightArrowLeft}
            className="text-2xl md:text-3xl text-white pr-3"
          />
          <p className="text-center">Easy Returns</p>
        </div>
        <div className="flex flex-col items-center space-y-4 md:space-y-2">
          <FontAwesomeIcon
            icon={faAward}
            className="text-2xl md:text-3xl text-white pr-3"
          />
          <p className="text-center">Quality Products</p>
        </div>
      </div>
      <hr />
      <div className="px-7 md:px-36 flex flex-col md:flex-row justify-between py-7 bg-gray-300">
        <div>
          <Link to="/">
            <h1 className="text-3xl font-semibold text-ambhosOrange">
              BrioCart
            </h1>

            {/* <img
              className="w-52 cursor-pointer"
              src="https://ambhos-webapp-assets.s3.ap-south-1.amazonaws.com/ambhos_full_logo.png"
              onClick={() => {
                handleScroll();
              }}
              alt="Ambhos"
            /> */}
          </Link>
          <div className="mt-5 w-80 text-gray-500">
            <p>
              Subscribe to our newsletter to receive our latest notifications to
              your inbox daily.
            </p>
            {isSubmitted ? (
              <div className="mt-2">
                <FontAwesomeIcon
                  className="text-green-600 mr-1"
                  icon={faCircleCheck}
                />
                <small className="w-56 text-center">
                  Thanks for Subscribing.
                </small>
              </div>
            ) : (
              <div>
                <input
                  type="email"
                  name="email"
                  value={subscribeFormData.email}
                  onChange={handleChange}
                  className="outline-none mt-3 p-1 border-2 border-ambhosOrange rounded-s-md"
                />
                <button
                  onClick={handleSubmit}
                  className="m-0 p-1 border-2 border-ambhosOrange rounded-e-md bg-ambhosOrange text-white"
                >
                  <p className="active:scale-95">Subscribe</p>
                </button>
                {errors.email && (
                  <small className="block text-red-500">{errors.email}</small>
                )}
              </div>
            )}
            <div className="mt-7 w-64 flex justify-between">
              <a
                href="https://www.youtube.com/@AMBHOS"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon className="text-3xl" icon={faYoutube} />
              </a>
              <a
                href="https://www.facebook.com/ambhos.official/"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon className="text-3xl" icon={faFacebook} />
              </a>
              <a
                href="https://www.instagram.com/ambhos_official"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon className="text-3xl" icon={faInstagram} />
              </a>
              <a
                href="https://www.linkedin.com/company/ambhos"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon className="text-3xl" icon={faLinkedin} />
              </a>
              <a
                href="https://twitter.com/AMBHOS_official"
                target="_blank"
                rel="noreferrer"
              >
                <FontAwesomeIcon className="text-3xl" icon={faTwitter} />
              </a>
            </div>
          </div>
        </div>
        <div className="w-2/3 flex flex-col">
          <div className="flex flex-col md:flex-row justify-between py-7 md:p-7">
            <div className="mb-3">
              <h4 className="font-bold text-xl md:mb-3">Shop</h4>
              <div>
                <p>
                  <Link to="/events">Men's Wear</Link>
                </p>
                <p>
                  <Link to="/services">Women's Wear</Link>
                </p>
                <p>
                  <Link to="/store">Kid's Wear</Link>
                </p>
              </div>
            </div>
            <div className="mb-3">
              <h4 className="font-bold text-xl md:mb-3">Policies</h4>
              <div>
                <p>
                  <Link to="/policies#faqs">FAQs</Link>
                </p>
                <p>
                  <Link to="/policies#privacy-policy">Privacy Policy</Link>
                </p>
                <p>
                  <Link to="/policies#terms&conditions">
                    Terms and Conditions
                  </Link>
                </p>
              </div>
            </div>
            <div className="mb-3">
              <h4 className="font-bold text-xl md:mb-3">Company</h4>
              <div>
                <p>
                  <Link to="/aboutus">About Us</Link>
                </p>
                <p>
                  <Link to="/blog">Blog</Link>
                </p>
                <Link to="/contact">Contact Us</Link>
              </div>
            </div>
          </div>
          <div className="flex space-x-4 text-3xl text-gray-500 md:justify-end md:pt-3">
            <FontAwesomeIcon icon={faCcMastercard} />
            <FontAwesomeIcon icon={faCcVisa} />
            <FontAwesomeIcon icon={faCcPaypal} />
          </div>
        </div>
      </div>
      <hr className="" />
      <div className="px-7 md:px-36 flex justify-between py-2 text-gray-500 bg-gray-200">
        <p>
          © Copyright Brioodev 2023
          {new Date().getFullYear() !== 2023 && "-" + new Date().getFullYear()}.
          All rights reserved - For Educational Purposes Only
        </p>
        <p className="">
          Developed by{" "}
          <a
            href="https://www.nikshit.me"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            brioodev
          </a>
        </p>
      </div>
      {/* <button className="scroll-btn"> */}
      {/* <FaArrowCircleUp onClick={handleScroll} /> */}
      {/* </button> */}
    </div>
  );
}
